import script from "./HeaderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderPage.vue?vue&type=script&setup=true&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=5b2cf41e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b2cf41e"]])

export default __exports__